import { makeStyles } from '@material-ui/core/styles'

export const wikiSectionStyle = makeStyles(theme => ({
  content: {
    width: '100%'
  },
  contentListItem: {
    margin: 0,
    padding: 0
  },
  list: {
    paddingBottom: 0
  },
  sectionListItem: {
    margin: 0,
    marginTop: theme.spacing(4),
    padding: 0,
    color: theme.palette.primary.main
  },
  title: {
    '& .MuiTypography-body1': {
      fontSize: '1.1rem'
    }
  }
}))
